import { PocIconButton } from 'commons/components/components-wrapper/poc-icon-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { TriggerActionsState } from '../constants/frontend-enums';
import { AutomationRulesCardLayout, AutomationRulesPocCard } from '../styled/automation-rules.style';
import { DeleteOptionParams } from '../types/automation-rules.type';

interface ConditionCardProps {
    content: React.ReactElement;
    id: number;
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
}

export const ConditionCard = React.memo(({ content, id, onDeleteOptionHandler }: ConditionCardProps) => {
    const { t } = useTranslation();
    return (
        <AutomationRulesPocCard>
            <AutomationRulesCardLayout className="spc-btw alg-itm-ctr" padding="24px">
                <AutomationRulesCardLayout className="alg-itm-ctr" padding="0">
                    <PocTypography variant="subtitle1">
                        {t('settings.system.automation-rules.logical-operators.if')}
                    </PocTypography>
                    {content}
                </AutomationRulesCardLayout>
                <div style={{ display: 'flex' }}>
                    <PocIconButton
                        icon="delete"
                        family="filled"
                        onClick={onDeleteOptionHandler({ id, parentArrayName: TriggerActionsState.conditions })}
                        data-testid={`delete-condition-${id}`}
                    />
                </div>
            </AutomationRulesCardLayout>
        </AutomationRulesPocCard>
    );
});
